import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import CustomerInsightPage from "../pages/customer-insight/page";
import ReportDetailPage from "../pages/report-detail/page";
import StrategyDetailPage from "../pages/strategy-detail/page";

const MarketInsightPage = lazy(() => import('../pages/market-insight/page'));
const AIStrategyPage = lazy(() => import('../pages/ai-strategy/page'));
const ScriptAssistantPage = lazy(() => import('../pages/script-assistant/page'));
const ProductSearchPage = lazy(() => import('../pages/product-search/page'));
const ReportAssistantPage = lazy(() => import('../pages/report-assistant/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/customer-insight" replace />
  },
  {
    path: '/market-insight',
    element: <MarketInsightPage />
  },
  {
    path: '/customer-insight',
    element: <CustomerInsightPage />
  },
  {
    path: '/ai-strategy',
    element: <AIStrategyPage />
  },
  {
    path: '/script-assistant',
    element: <ScriptAssistantPage />
  },
  {
    path: '/product-search',
    element: <ProductSearchPage />
  },
  {
    path: '/report-assistant',
    element: <ReportAssistantPage />
  },
  {
    path: '/report-detail',
    element: <ReportDetailPage />
  },
  {
    path: '/strategy-detail',
    element: <StrategyDetailPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/404',
    element: <NotFoundPage />
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />
  }
];

export default routes;
